import React, { Component } from 'react';
import Input from '../input';
import FormGroup from '../FormGroup';
import EditorComponent from '../Editor';
import Checkbox from '../checkbox';
import Button from '../button';

class AnswerItem extends Component {
  render() {
    return (
      <React.Fragment>
       {this.props.testType === 1 && (
            <FormGroup className="form-group_small_margin">
              <Checkbox
                onChange={this.props.changeCorrectAnswer.bind(
                  this,
                  this.props.index
                )}
                checked={this.props.answer.correct}
                text={`Правильный вариант ответа`}
              />
            </FormGroup>
       )}
        <FormGroup className="form-group_small_margin">
          <Input
            value={this.props.answer.text}
            onChange={this.props.changeTextAnswer.bind(this, this.props.index)}
            title={`Вариант ответа ${this.props.index + 1}`}
          />
        </FormGroup>
        {this.props.testType !== 1 && (
          <FormGroup className="form-group_small_margin">
              <Input
                  value={this.props.answer.group}
                  onChange={this.props.changeTextGroup.bind(this, this.props.index)}
                  title={`Название группы`}
              />
          </FormGroup>
        )}
          {this.props.testType === 1 && (
            <FormGroup className="form-group_small_margin">
              <EditorComponent
                title={`Комментарий к варианту ответа ${this.props.index + 1}`}
                editorState={this.props.answer.comment}
                onEditorStateChange={this.props.changeCommentAnswer.bind(
                  this,
                  this.props.index
                )}
              />
            </FormGroup>
          )}
{/*          <FormGroup className="form-group_small_margin">
              <FilePond
                  acceptedFileTypes={['image/*']}
                  allowFileEncode={true}
                  name={'backgroundImage'}
                  onaddfile={(error, file) => this.addImage('backgroundImage')}
                  onremovefile={() => this.addImage('backgroundImage')}
              />
          </FormGroup>*/}

        {this.props.lengthAnswers === this.props.index + 1 && (
          <div className="answer-buttons">
            <Button
              textButton="Новый вариант ответа"
              onClick={this.props.createAnswer}
            />
            {this.props.lengthAnswers > 2 && (
              <Button
                classList="btn_secondary answer-remove-btn"
                textButton="Удалить"
                onClick={this.props.removeAnswer}
              />
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default AnswerItem;
